import { type FC } from "react";

import { IconText } from "mds/components/IconText";
import { PersonClassIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectPresentClassUsersFilteredByRoom } from "store/selectors/virtual-class-users-sorting";

const MIN_PARTICIPANTS_TO_SHOW = 4;

export const ParticipantCountIndicator: FC = () => {
  const participants = useAppSelector(selectPresentClassUsersFilteredByRoom);
  const count = participants.length;

  if (count < MIN_PARTICIPANTS_TO_SHOW) {
    return null;
  }

  return (
    <IconText
      className="gap-1.5 text-black-tint-55"
      iconStart={<PersonClassIcon size="m" />}
      text={count}
    />
  );
};
